import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Campaign } from '@feathr/blackbox';
import { Tooltip } from '@feathr/components';
import { CampaignState } from '@feathr/extender/components';

interface IProps {
  campaign: Campaign;
}

function CampaignStatusChip({ campaign }: Readonly<IProps>): JSX.Element {
  const state = campaign.get('state');
  const statusMessages = campaign.get('status_messages');

  const shouldShowTooltip = statusMessages && statusMessages.length > 0;

  const campaignState = <CampaignState name={'campaign-status'} state={state} />;

  if (shouldShowTooltip) {
    const tooltipContent = statusMessages.join(', ');
    return (
      <Tooltip position={'right'} title={tooltipContent}>
        {campaignState}
      </Tooltip>
    );
  }

  return campaignState;
}

export default observer(CampaignStatusChip);
